import React from "react";
import { DownloadIcon } from "@icons";
import { Loader } from "@design-system/Loader/Loader";
import { Button } from "@design-system/Button/Button";
import { Tooltip } from "@design-system/Tooltip/Tooltip";

interface Props {
    onDownload: () => void;
    disabled: boolean;
    loading: boolean;
}

export const BankReconciliationReportDownload: React.FC<Props> = ({
    onDownload,
    disabled,
    loading,
}) => (
    <Tooltip content="Download report">
        <Button
            variant="primary"
            iconOnly
            size="md"
            disabled={disabled || loading}
            onClick={onDownload}
            aria-label="Download report"
        >
            {loading ? <Loader inline /> : <DownloadIcon />}
        </Button>
    </Tooltip>
);
